export const HttpStatus = {
  // Successful responses
  OK: 200, // Success
  Created: 201, // Created
  Accepted: 202, // Accepted (e.g., chunk uploaded)
  NoContent: 204, // No Content

  // Client errors
  BadRequest: 400,
  Unauthorized: 401,
  Forbidden: 403,
  NotFound: 404,
  Conflict: 409,
  UnprocessableEntity: 422,

  // Server errors
  InternalServerError: 500,
  NotImplemented: 501,
  BadGateway: 502,
  ServiceUnavailable: 503,
} as const;

export type HttpStatusCode = (typeof HttpStatus)[keyof typeof HttpStatus];
